import { render, staticRenderFns } from "./revenues.vue?vue&type=template&id=924a39e0"
import script from "./revenues.vue?vue&type=script&lang=js"
export * from "./revenues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports